export enum ChatFinishReason {
    Stop = "Stop",
    Length = "Length",
    ContentFilter = "ContentFilter",
    ToolCalls = "ToolCalls",
    FunctionCall = "FunctionCall",
    Error = "Error",
}
